const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Typography, CardHeader, Link, Backdrop, CircularProgress } from '@mui/material';

class ContestantTitle extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '', gtitle_color: '', title_bck: '' };
    }

    componentDidMount = () => {
        let color_font = (this.props.view == 'grid') ? this.props.settings.color.votes_cont_title_color_grid : this.props.settings.color.votes_cont_title_color;
        let bg_color = (this.props.view == 'grid') ? 'transparent' : this.props.settings.color.votes_cont_title_bgcolor;
        this.setState({
            gtitle_color: color_font, title_bck: bg_color
        });
    }

    toggleHover = (value) => () => {
        this.setState({ gtitle_color: value })
    }

    toggleleave = (value) => () => {
        this.setState({ gtitle_color: value })
    }

    render() {
        const { t } = this.props;
        const { votes_cont_title_font_size, votes_cont_title_color_grid, votes_cont_title_color_hover_grid, votes_cont_title_color, votes_cont_title_color_hover } = this.props.settings.color;

        const font_colr = (this.props.view == 'grid') ? votes_cont_title_color_grid : votes_cont_title_color;
        const font_hov_colr = (this.props.view == 'grid') ? votes_cont_title_color_hover_grid : votes_cont_title_color_hover;

        const design = (this.props.view == 'grid') ? 'row' : 'column';

        const contest_title = (typeof this.props.title_alocation !== "undefined") ? this.props.title_alocation : null;
        const { common } = this.props.settings;

        const hideCategory = this.props.hideCategory ? 1 : 0;
        if (this.props.singlepost) {
            return (
                <div className={"wpvc_card_conthead_" + design} style={{ backgroundColor: this.state.title_bck }}>
                    {contest_title == "on_grid" &&
                        <CardHeader
                            className={"wpvc_card_header_" + design}
                            title={
                                <Typography style={{ fontSize: votes_cont_title_font_size + 'px', 'color': this.state.gtitle_color }}
                                    onMouseOver={this.toggleHover(font_hov_colr, 'title')} onMouseLeave={this.toggleleave(font_colr, 'title')}
                                    variant="h5" className="wpvc_grid_header" >
                                    {common.vote_disable_single != 'on' &&
                                        <Link style={{ fontSize: votes_cont_title_font_size + 'px', 'color': this.state.gtitle_color }} href={this.props.singlepost.wpvc_custom_link || this.props.singlepost.link} target={common.vote_newlink_tab == 'on' ? '_blank' : '_self'}>{this.props.singlepost.post_title}</Link>
                                    }
                                    {common.vote_disable_single == 'on' &&
                                        this.props.singlepost.post_title
                                    }
                                </Typography>
                            }
                            subheader={(this.props.short.termdisplay == 1) ? <Typography className="wpvc_card_sub_header">{t("fr_category")}{this.props.singlepost.term_name}</Typography> : ''}
                        />
                    }
                    {contest_title == null &&
                        <div>
                            <Typography
                                variant="h5"
                                className="wpvc_grid_header"
                                style={{ fontSize: votes_cont_title_font_size + 'px', 'color': this.state.gtitle_color }}
                                onMouseOver={this.toggleHover(font_hov_colr, 'title')}
                                onMouseLeave={this.toggleleave(font_colr, 'title')}
                            >
                                {common.vote_disable_single != 'on' &&
                                    <Link href={this.props.singlepost.wpvc_custom_link || this.props.singlepost.link} target={common.vote_newlink_tab == 'on' ? '_blank' : '_self'}>{this.props.singlepost.post_title}</Link>
                                }
                                {common.vote_disable_single == 'on' &&
                                    this.props.singlepost.post_title
                                }
                            </Typography>
                            {
                                hideCategory === 0 &&
                                <React.Fragment>
                                    {this.props.short.termdisplay == 1 &&
                                        <Typography
                                            className="wpvc_card_sub_header">
                                            {t("fr_category")}{this.props.singlepost.term_name}
                                        </Typography>
                                    }
                                </React.Fragment>
                            }

                        </div>
                    }
                </div>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

export default connect()(withTranslation("translations")(ContestantTitle));
